<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-09-03 10:54:14
 * @LastEditors: lkz
 * @LastEditTime: 2021-09-09 14:56:24
 -->
<template>
  <div class="item-template-view">
    <!-- 数字型 -->
    <template v-if="wordType === 1">
      <el-input v-model.trim="val" @input="checkNumber" :placeholder="placeholder"></el-input>
    </template>
    <!-- 日期型 -->
    <template v-else-if="wordType === 2">
      <el-date-picker
        v-model="val"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        clearable
        >
      </el-date-picker>
    </template>
    <!-- 枚举型 -->
    <template v-else-if="wordType === 3">
      <el-select :multiple="multiples" collapse-tags v-model="val" @change='changeVal' clearable>
        <el-option
          v-for="(item, idx) in options"
          :key="idx"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </template>
    <!-- 文本型 -->
    <template v-if="wordType === 4">
      <el-input v-model.trim="val" :placeholder="placeholderStr(placeholder)" clearable></el-input>
    </template>
    <!-- 单选框 -->
    <template v-if="wordType === 5">
      <el-radio-group v-model="val" clearable>
        <el-radio
          v-for="(item, idx) in options"
          :key="idx"
          :label="item.id">
          {{item.name}}
        </el-radio>
      </el-radio-group>
    </template>
    <!-- 复选框 -->
    <template v-if="wordType === 6">
      <el-checkbox-group v-model="val" clearable>
        <el-checkbox
          v-for="(item, idx) in options"
          :key="idx"
          :label="item.id">
          {{item.name}}
        </el-checkbox>
      </el-checkbox-group>
    </template>
    <!-- 下拉框多选 -->
    <template v-if="wordType === 7">
      <el-select clearable multiple collapse-tags v-model="val">
        <el-option
          v-for="(item, idx) in options"
          :key="idx"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </template>
    <!-- 下拉框级联 -->
    <template v-if="wordType === 8">
      <el-cascader
        v-model="val"
        :options="options"
        :props="cascaderProps"
        collapse-tags
        clearable>
      </el-cascader>
    </template>
  </div>
</template>

<script>
export default {
  name: 'itemTemplate',
  props: {
    wordType: Number, // 控制控件类型 1数字型,2日期型,3枚举型,4文本型,5单选框,6复选框,7下拉框多选 8下拉框级联
    value: [Array, Number, String], // 模板接收参数
    placeholder: String,
    options: [Array, String], // 枚举选项
    cascaderProps: {
      type: [Object, String],
      default() {
        return {
          value: 'id',
          label: 'name'
        }
      }
    },
    multiples: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    // 监听父组件参数变化，实时同步
    value(newVal) {
      this.val = newVal
    },
    // 监听组件参数变化，实时通知给父组件
    val(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    // 确保输入的都是数字
    checkNumber(val) {
      const reg = /\D*/g
      this.val = val.replace(reg, '')
    },
    // 工单状态当选择全部的时候禁止选择其他
    changeVal(val) {
      if (this.multiples) {
        val.forEach((item) => {
          if (item === null) {
            this.val = [null]
          }
        })
      }
    },
    placeholderStr(val) {
      let str = ''
      if (val === '手机号码') {
        str = '多个号码请用英文";”分隔'
      } else if (val === '固定电话') {
        str = '区号必填且用"-"分隔'
      } else {
        str = val
      }
      return str
    }
  }
}
</script>

<style lang="less" scoped>
.item-template-view{
  /deep/ .el-radio-group{
    .el-radio{
      margin-left: 0;
      line-height: 2;
    }
  }
  /deep/ .el-select__tags + .el-input .el-input__inner{
    min-height: 32px;
  }
}
</style>
